/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../../client/js/components/NoData'
import SelectionToggle from '../../../../client/js/components/selection/SelectionToggle'
import InvoiceListItem from './InvoiceListItem'
import { getInvoiceLinkTemplate } from '../../lib/links/invoiceLinks'

export type InvoiceListProps = {
  items: Invoice[],
  itemLink?: string
}

function InvoiceList (props: InvoiceListProps) {
  const {
    items,
    itemLink = getInvoiceLinkTemplate()
  } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={50}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th w={120}>
            <FormattedMessage
              id="status"
              defaultMessage="État"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="reference"
              defaultMessage="Référence"
            />
          </Table.Th>
          <Table.Th w={120}>
            <FormattedMessage
              id="due_date"
              defaultMessage="Échéance"
            />
          </Table.Th>
          <Table.Th w={120} ta="end">
            <FormattedMessage
              id="total"
              defaultMessage="Total"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="customer"
              defaultMessage="Client"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="estate"
              defaultMessage="Bien"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <InvoiceListItem
              item={item}
              itemLink={itemLink}
              key={item.id}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={8}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default InvoiceList
